import { c as _c } from "react/compiler-runtime";
import type { DecisionStatus, UserTimelineEventBusinessOwnerCompletedKyc } from '@onefootprint/request-types/dashboard';
import { ActorKind } from '@onefootprint/types';
import { LinkButton } from '@onefootprint/ui';
import { Trans, useTranslation } from 'react-i18next';
import Actor from '../actor';
type BoCompletedKycHeaderProps = {
  data: UserTimelineEventBusinessOwnerCompletedKyc['data'];
};
const BoCompletedKycHeader = t0 => {
  const $ = _c(27);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    fpId,
    decision: t2
  } = data;
  const {
    status,
    workflowKind,
    source
  } = t2;
  if (workflowKind === "document") {
    return null;
  }
  let statusToText;
  let t3;
  if ($[1] !== status || $[2] !== t) {
    statusToText = {
      fail: t(_temp),
      pass: t(_temp2),
      none: t(_temp3)
    };
    t3 = t(_temp4, {
      status: statusToText[status]
    });
    $[1] = status;
    $[2] = t;
    $[3] = statusToText;
    $[4] = t3;
  } else {
    statusToText = $[3];
    t3 = $[4];
  }
  const outcome = t3;
  const t4 = `/users/${fpId}`;
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp5);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <LinkButton href={t4}>{t5}</LinkButton>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const beneficialOwner = t6;
  if (source.kind === ActorKind.footprint) {
    let t7;
    if ($[10] !== beneficialOwner) {
      t7 = {
        beneficialOwner
      };
      $[10] = beneficialOwner;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== outcome) {
      t8 = {
        outcome
      };
      $[12] = outcome;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== t7 || $[15] !== t8) {
      t9 = <div className="flex items-center gap-1"><p className="text-body-2 md:flex md:gap-1 md:text-nowrap"><Trans ns="entity-details" i18nKey={_temp6} components={t7} values={t8} /></p></div>;
      $[14] = t7;
      $[15] = t8;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    return t9;
  }
  const t7 = statusToText[status];
  let t8;
  if ($[17] !== t7) {
    t8 = {
      decision: t7
    };
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== source) {
    t9 = <Actor actor={source} />;
    $[19] = source;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== beneficialOwner || $[22] !== t9) {
    t10 = {
      actor: t9,
      beneficialOwner
    };
    $[21] = beneficialOwner;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex items-center gap-1"><p className="text-body-2 md:flex md:gap-1 md:text-nowrap"><Trans ns="entity-details" i18nKey={_temp7} values={t8} components={t10} /></p></div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default BoCompletedKycHeader;
function _temp($) {
  return $.onboardingDecisionEvent.decisionStatus.fail;
}
function _temp2($_0) {
  return $_0.onboardingDecisionEvent.decisionStatus.pass;
}
function _temp3($_1) {
  return $_1.onboardingDecisionEvent.decisionStatus.none;
}
function _temp4($_2) {
  return $_2.onboardingDecisionEvent.withOutcome;
}
function _temp5($_3) {
  return $_3.boCompletedKyc.beneficialOwner;
}
function _temp6($_4) {
  return $_4.auditTrail.timeline.boCompletedKyc.header;
}
function _temp7($_5) {
  return $_5.auditTrail.timeline.boCompletedKyc.manualReviewHeader;
}